import axios from '@/libs/axios'

export default {
  getCustomerNotes(customerId, params) {
    return axios.get(`/customers/${customerId}/notes`, { params })
  },
  postCustomerNote(customerId, payload) {
    return axios.post(`/customers/${customerId}/notes`, payload)
  },
  deleteCustomerNote(customerId, noteId) {
    return axios.delete(`/customers/${customerId}/notes/${noteId}`)
  },
}
